import { Box, Button, Modal, TextField } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const EditDateModal = ({ isOpen, onClose, user, saveExpirationDate }) => {
    const [newExpirationDate, setNewExpirationDate] = useState(null);

    // Función para convertir "DD/MM/YYYY" → "YYYY-MM-DD"
    const transformDate = (dateStr) => {
        if (!dateStr) return null; 
        const [day, month, year] = dateStr.split('/').map(Number);
        return dayjs(`${year}-${month}-${day}`); // Devuelve formato compatible
    };

    useEffect(() => {
        if (user.expirationDate) {
            setNewExpirationDate(transformDate(user.expirationDate));
        }
    }, [user.expirationDate]);

    const extendExpiration = (months) => {
        setNewExpirationDate(prev => prev.add(months, 'month'));
    };

    const onSave = () => {
        saveExpirationDate(newExpirationDate.format("DD/MM/YYYY"));
        onClose(false);
    };

    const isExpired = newExpirationDate && newExpirationDate.isBefore(dayjs(), 'day');

    return (
        <Modal open={isOpen} onClose={() => onClose(false)}>
            <Box className="edit_date_modal">
                <h2>Editar Fecha de Expiración</h2>

                {/* Botones de ajuste rápido */}
                <Box sx={{ display: 'flex', gap: 1, marginBottom: 2, flexWrap: 'wrap' }}>
                    <Button variant="contained" sx={{flex: 1, whiteSpace: 'nowrap'}} onClick={() => extendExpiration(1)}>+1 Mes</Button>
                    <Button variant="contained" sx={{flex: 1, whiteSpace: 'nowrap'}} onClick={() => extendExpiration(3)}>+3 Meses</Button>
                    <Button variant="contained" sx={{flex: 1, whiteSpace: 'nowrap'}} onClick={() => extendExpiration(6)}>+6 Meses</Button>
                    <Button variant="contained" sx={{flex: 1, whiteSpace: 'nowrap'}} onClick={() => extendExpiration(12)}>+1 Año</Button>
                </Box>

                {/* Date Picker de Material UI */}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label="Selecciona una fecha"
                        value={newExpirationDate}
                        minDate={dayjs()} // No permite fechas anteriores a hoy
                        onChange={(newValue) => setNewExpirationDate(newValue)}
                        format="DD/MM/YYYY"
                        slotProps={{
                            textField: {
                                error: isExpired,
                                helperText: isExpired ? "Fecha vencida" : "",
                                fullWidth: true
                            }
                        }}
                        sx={{
                            '& .MuiInputLabel-root': {
                                color: 'var(--color-dark)',
                                // fontSize: '0.7rem' // Tamaño de la etiqueta
                            },
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': { borderColor: 'var(--color-dark-variant)' },
                                '&:hover fieldset': { borderColor: 'var(--color-dark)' },
                                '&.Mui-focused fieldset': { borderColor: 'var(--color-dark)' },
                            },
                            '& .MuiInputBase-input': {
                                color: 'var(--color-dark)',
                                fontSize: '0.8rem', // Tamaño del texto de entrada
                            },
                            '& .MuiSvgIcon-root': { color: 'var(--color-dark)' }, // Color del ícono
                        }}
                    />
                </LocalizationProvider>

                {/* Botones de guardar y cancelar */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, marginTop: 2 }}>
                    <Button onClick={() => onClose(false)} color="primary">Cancelar</Button>
                    <Button onClick={onSave} style={{backgroundColor: 'var(--color-success)'}} variant="contained" disabled={isExpired} >
                        Guardar
                    </Button>
                </Box>
            </Box>
        </Modal>
    )
}

export default EditDateModal